module.exports = __webpack_public_path__ + "cf3d8e135791889c1f0138f23fb989d1.MP3";